import React from 'react';
import TextField from 'shared/components/text-field/TextField';

const MealTip = props => {
  return (
    <div className="meal-tip">
      <TextField
        type="text"
        name="tip"
        label="Tip"
        placeholder="You can replace berries with honey to get a sweet taste."
        onChange={props.handleTipChange}
      />
    </div>
  );
};

export default MealTip;
